<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">{{data.title}} Confirmation!</h4>
  <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onCancel()" title="Close"></i>
</div>
<div class="modal-body text-grey">
  <p>
    {{data.message}}
  </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">{{data.noBtnText}}</button>
  <button type="button" class="btn btn-primary" (click)="onSubmit()" cdkFocusInitial>{{data.yesBtnText}}</button>
</div>